var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailUpdate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2928 0C11.1868 0 12.0468 0.353333 12.6795 0.987333C13.3128 1.62 13.6668 2.47333 13.6668 3.36667V8.63333C13.6668 10.4933 12.1535 12 10.2928 12H3.70683C1.84616 12 0.333496 10.4933 0.333496 8.63333V3.36667C0.333496 1.50667 1.8395 0 3.70683 0H10.2928ZM11.3535 4.36L11.4068 4.30667C11.5662 4.11333 11.5662 3.83333 11.3995 3.64C11.3068 3.54067 11.1795 3.48 11.0468 3.46667C10.9068 3.45933 10.7735 3.50667 10.6728 3.6L7.66683 6C7.28016 6.32067 6.72616 6.32067 6.3335 6L3.3335 3.6C3.12616 3.44667 2.8395 3.46667 2.66683 3.64667C2.48683 3.82667 2.46683 4.11333 2.6195 4.31333L2.70683 4.4L5.74016 6.76667C6.1135 7.06 6.56616 7.22 7.04016 7.22C7.51283 7.22 7.9735 7.06 8.34616 6.76667L11.3535 4.36Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailUpdate);
export default __webpack_public_path__ + "static/media/mailUpdate.cff628370a5a73fd426689e3bfaf9a2b.svg";
export { ForwardRef as ReactComponent };